import * as Yup from "yup";

export const addressSchema = Yup.object().shape({
  address: Yup.string().required("Address is required"),
  address2: Yup.string(),
  state: Yup.string().required("State is required"),
  // postalCode: Yup.string()
  //   .optional()
  //   .required("postalCode is required")
  //   .length(6, "postalCode must be 6 digits"),
});

export type addressForm = Yup.InferType<typeof addressSchema>;

export const createBoatSchema = Yup.object().shape({
  brand: Yup.string().required("Brand Name is required"),
  model: Yup.string().required("Boat Model is required"),
  color: Yup.string().required("Boat Color is required"),
  boatYear: Yup.date().required("Boat Year is required"),
  lastMaintenance: Yup.date().required("Last Maintenance is required"),
});

export type createBoatForm = Yup.InferType<typeof createBoatSchema>;

export const boatPriceSchema = Yup.object().shape({
  hourlyRate: Yup.number()
    .required("Hourly Rate is required")
    .typeError("Hourly Rate must be a number"),
  penaltyFee: Yup.number()
    .required("Penalty Fee is required")
    .typeError("Penalty Fee must be a number")
    .min(0, "Penalty feel must be between 1 and 100")
    .max(100, "Penalty feel must be between 1 and 100"),
  seatCapacity: Yup.string().required("Seat Capacity is required"),
  tripAvailabilityOptions: Yup.string().required("Availability is required"),
});

export type boatPriceForm = Yup.InferType<typeof boatPriceSchema>;
